namespace GeniuzPOS.InitialData {
    export interface PsShopTypeRow {
        Id?: number;
        ShopTypeId?: string;
        ShopTypeName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ShopTypeFullName?: string;
    }

    export namespace PsShopTypeRow {
        export const idProperty = 'ShopTypeId';
        export const nameProperty = 'ShopTypeFullName';
        export const localTextPrefix = 'InitialData.PsShopType';
        export const lookupKey = 'InitialData.PsShopType';

        export function getLookup(): Q.Lookup<PsShopTypeRow> {
            return Q.getLookup<PsShopTypeRow>('InitialData.PsShopType');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:ร้านค้าและคลัง:ร้านค้า:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:ร้านค้าและคลัง:ร้านค้า:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:ร้านค้าและคลัง:ร้านค้า:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:ร้านค้าและคลัง:ร้านค้า:Modify';

        export declare const enum Fields {
            Id = "Id",
            ShopTypeId = "ShopTypeId",
            ShopTypeName = "ShopTypeName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ShopTypeFullName = "ShopTypeFullName"
        }
    }
}
